export default __webpack_public_path__ + "274853cb0773ad782783c35eb89d0b4e.png";